module.exports = __webpack_public_path__ + "22452e2e8a314877d433bd8ca64d475c.jpg";